import { trigger, state, style, transition, animate } from '@angular/animations';
import {
  ChangeDetectorRef,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren, SecurityContext, Renderer2
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ExportDataService, PixelService } from '../../../../shared';
import * as _ from 'lodash';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { DatePipe } from '@angular/common';
import { TrendChartForecastComponent } from '../../../../shared/elements/trend-chart-forecast/trend-chart-forecast.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReportsService } from '../../../../reports/reports.service';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { ToastrService } from 'ngx-toastr';
import { ToastrUtilsService, TOASTR_CONFIG } from '../../../../shared/utils/toastr-utils';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { ExportFilePopupComponent } from '../../../../shared/elements/export-file-popup/export-file-popup.component';
import { InbuiltUtilityService } from '../../../../reports/inbuilt-report-v2/inbuilt-utility.service';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';
import { Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-forcast-management-table',
  templateUrl: './forcast-management-table.component.html',
  styleUrl: './forcast-management-table.component.css',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)'))
    ])
  ],
  standalone: false
})
export class ForcastManagementTableComponent implements OnChanges, AfterViewInit {
  Infra;
  @Input() forecastTableData: any;
  @Input() TABLE_CONFIG: any;
  @Input() COLUMNS: any;
  @Input() expanded_columns: any = [];
  @Input() pageSize;
  @Input() pageIndex;
  @Input() isForecastAdmin: boolean;
  @Input() isForecastSRM: boolean;
  @Input() clickedChip: any;
  @Input() selectedOwnerType: any;
  @Input() isLeaderOrOwnerSelected: any;
  @ViewChild('empTbSort') empTbSort = new MatSort();
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('childpagination') childpaginator: QueryList<MatPaginator>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Output() updateExpandedColData: EventEmitter<any> = new EventEmitter();
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  toggleChecked: boolean = true;
  displayedColumns: any = [];
  displayedChildColumns: any = [];
  childDataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  showUOMrateData: boolean = false;
  displayedChildHeaders = [
    'No',
    'rate_uom',
    'header1',
    'header2',
    'header3',
    'header4',
    'header5',
    'header6',
    'header7'
  ];
  @ViewChild('addServicePopup', { static: false }) addServicePopup;
  @ViewChild('exportFileAsPopup', { static: false }) exportFileAsPopup: ExportFilePopupComponent;
  @ViewChild('viewForecastApplicationChart') applicationChart;
  appDataForAddService = {};
  enableEditForAddService = false;
  @Input() isForecastTableDataLoaded: boolean = false;
  isInitialLoad: boolean = true;
  @Input() masterServicesData: any = {};
  currentUser = '';
  @Input() forecastDetailsMap: Map<string, string>;
  @ViewChild('toggle') toggle;
  @Input() isForecastTableUpdated: boolean;
  isToggleChange: boolean = false;
  @Output() refreshAggregatedData = new EventEmitter();
  allRowsExpanded: boolean = false;
  @ViewChild(TrendChartForecastComponent) childComponent: TrendChartForecastComponent;
  pendAttesCount: number = 0;
  isPendingAttesFilterApplied: boolean = false;
  oldDataSource: Array<any> = [];
  allNewApps: any = [];
  modalType: string = 'service';
  marginLessDetails: object = {};
  @Input() RealFilter: any;
  @Input() forecastCycleType: any;
  showDropdownMenu = false;
  excelDropdownData: any = [];
  exportLoading: boolean = false;
  loadingExportKey: string | null = null;
  reportPayload: { Page_name?: string; Report_Type?: string | string[] } = {};
  private exportPayloadPending: any = null;
  isJSONeditorEnabled = false;
  isJsonEditorPopupOpen = false;
  activeDropdownItem: any = null;
  @ViewChild('jsonEditorPopup', { static: false }) jsonEditorPopup: any;
  private readonly destroy$ = new Subject<void>();
  private exportResponseData: any = null;
  private shouldTriggerAdfForExport: boolean = false;

  constructor(
    private exportService: ExportDataService,
    private maintenanceService: MaintenanceService,
    private cd: ChangeDetectorRef,
    private datepipe: DatePipe,
    private pixelService: PixelService,
    private sanitizer: DomSanitizer,
    private ReportsService: ReportsService,
    private sharedAuthService: SharedAuthService,
    private toastr: ToastrService,
    private toastrUtilsService: ToastrUtilsService,
    private activatedRoute: ActivatedRoute,
    private inbuiltUtilityService: InbuiltUtilityService,
    private dialog: MatDialog
  ) {}


  ngOnInit() {
    this.getNewApplication();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.currentUser = this.sharedAuthService.getMsid() || this.sharedAuthService.getMsid() || '';
    this.showUOMrateData = false;
    this.toggleChecked = true;
    if (changes.isForecastTableUpdated && changes.isForecastTableUpdated.currentValue && this.toggle) {
      this.toggle.checked = true;
      this.allRowsExpanded = false;
      this.isPendingAttesFilterApplied = false;
    }
    if (this.isForecastTableDataLoaded && this.isForecastTableUpdated) {
      this.displayedChildHeaders = [
        'No',
        'rate_uom',
        'header1',
        'header2',
        'header3',
        'header4',
        'header5',
        'header6',
        'header7'
      ];
      this.displayedColumns = this.COLUMNS.map(element => element.key);
      const childColumns = [];
      this.expanded_columns.forEach(element => {
        if (element.key == 'sv_desc') {
          element.width = '18% !important';
        }
        childColumns.push(element.key);
      });
      this.displayedChildColumns = childColumns;
      this.getDatasource();
    }
    if(this.forecastDetailsMap && this.forecastDetailsMap.size > 0){
      this.getReportDetailsForExcelExport();
    }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.empTbSort;
  }

  getFilteredInfraMonthlyData(element) {
    if (!element || !element.ask_global_id || !element.services || element.services.length === 0) {
      console.warn('Invalid element provided to getFilteredInfraMonthlyData');
      return;
    }
    const appId = element.ask_global_id.toString();
    const payload = {};
    payload['ask_global_id'] = appId;
    const descArray = element.services.map(service => service.sv_desc);
    payload['sv_desc'] = descArray;
    this.maintenanceService.getApplicationStats(payload).subscribe(
      data => {
        this.Infra = data['monthlyData'];
      },
      error => {
        console.error(error.message || 'Error fetching data'); // Log the error
        this.Infra = undefined; // Ensure Infra is not set on error
      }
    );
  }

  getDatasource() {
    this.dataSource = new MatTableDataSource(this.forecastTableData);
    this.pendAttesCount = 0;
    this.dataSource.data.forEach((element, index) => {
      element['id'] = index;
      const sorttedServiceLst = this.sortService(element.services);

      if (element.pending_Services > 0) {
        this.pendAttesCount++;
      }
      element['childDataSource'] = new MatTableDataSource(sorttedServiceLst);
      if (!this.isToggleChange) {
        element.expand = false;
      }
    });
    this.dataSource.paginator = this.paginator;
    this.TABLE_CONFIG.totalItems = this.dataSource && this.dataSource.data.length > 0 ? this.dataSource.data.length : 0;
    this.isToggleChange = false;
  }

  toggleChanged(ev) {
    this.toggleChecked = ev.checked;
    this.isToggleChange = true;
    this.updateExpandedColData.emit(this.toggleChecked);
  }

  applicationView(element) {
    this.getFilteredInfraMonthlyData(element);
    this.applicationChart.show();
    this.pixelService.sendclicktopixel('Forecast Application Chart');
  }
  hideModal() {
    if (this.childComponent) {
      this.childComponent.removeData();
    }
  }
  expandDetailRow(element, isExpand) {
    if (element && element['id'] >= 0) {
      element.expand = isExpand;
      this.cd.detectChanges();
      this.innerTables.forEach((table, index) => {
        (table.dataSource as MatTableDataSource<any>).paginator = this.childpaginator.toArray()[index];
      });
      this.allRowsExpanded = true;
    }
  }

  collapseDetailRow(element) {
    element.expand = false;
    if (this.checkForAllExpand(true) > 0) {
      this.allRowsExpanded = true;
    } else {
      this.allRowsExpanded = false;
    }
  }

  getNavigationLink(col, element) {
    switch (col.key) {
      case 'app_name':
        return '/application-hub?appId=' + '%22' + element.ask_global_id + '%22';
        break;
    }
  }

  sortData(event) {
    let sort: any[] = [];
    if (event.direction) {
      sort = [[event.active, event.direction]];
    }
    this.dataSource.sort = this.empTbSort;
  }

  navigateToViewService(el) {
    const baseUrl = window.location.origin;
    const urlParams = '?appId=' + encodeURIComponent(el.ask_global_id) + '&service=' + encodeURIComponent(el.service ?? '');
    const wqUrl = baseUrl + '/maintenanceV4/forecast-service' + urlParams;
    window.open(wqUrl, '_blank');
  }

  exportToExcel() {
    const exportData = [];
    const volumeData = [];
    const chargeArr = [];
    if (this.forecastTableData.length == 0) {
      return false;
    }
    this.forecastTableData.forEach(element => {
      const exportJSON: any = {};
      exportJSON['Application Name'] = element.app_name ? element.app_name : '';
      exportJSON['Application ID'] = element.ask_global_id ? element.ask_global_id : '';
      exportJSON['LOB'] = element.cio_lob ? element.cio_lob : '';
      exportJSON['Decom Date'] = element.decom_date ? this.datepipe.transform(element['decom_date'], 'mediumDate') : '';
      exportJSON[this.forecastDetailsMap.get('previousYear_prev_no') + ' FY'] =
        element.Prev_FY_Total != null ? this.convertToDollar(element.Prev_FY_Total) : '';
      exportJSON[this.forecastDetailsMap.get('currentYear_prev_no') + ' Projections'] =
        element.Current_Projections_Total != null ? this.convertToDollar(element.Current_Projections_Total) : '';
      exportJSON[
        this.forecastDetailsMap.get('currentYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('previousForecastCycle') +
          ')'
      ] =
        element.Curr_Year_FC_Prev_Charges_Total != null
          ? this.convertToDollar(element.Curr_Year_FC_Prev_Charges_Total)
          : '';
      exportJSON[
        this.forecastDetailsMap.get('currentYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('currentForecastCycle') +
          ')'
      ] =
        element.Curr_Year_FC_Curr_Charges_Total != null
          ? this.convertToDollar(element.Curr_Year_FC_Curr_Charges_Total)
          : '';
      exportJSON[
        this.forecastDetailsMap.get('nextYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('previousForecastCycle') +
          ')'
      ] =
        element.Future_Year_FC_Prev_Charges_Total != null
          ? this.convertToDollar(element.Future_Year_FC_Prev_Charges_Total)
          : '';
      exportJSON[
        this.forecastDetailsMap.get('nextYear_prev_no') +
          ' FC (' +
          this.forecastDetailsMap.get('currentForecastCycle') +
          ')'
      ] =
        element.Future_Year_FC_Curr_Charges_Total != null
          ? this.convertToDollar(element.Future_Year_FC_Curr_Charges_Total)
          : '';
      const sorttedServiceLst = this.sortService(element.services);
      sorttedServiceLst.forEach(el => {
        const expData = {};
        expData['Application Name'] = element.app_name ? element.app_name : '';
        expData['Application ID'] = element.ask_global_id ? element.ask_global_id : '';
        expData['Service Name'] = el.sv_desc ? el.sv_desc : '';
        expData[this.forecastDetailsMap.get('previousYear_prev_no') + ' Rate'] =
          el.PY_Rate != null ? el.PY_Rate + ' / ' + el.Unit_Of_Measure : '';
        expData[this.forecastDetailsMap.get('currentYear_prev_no') + ' Rate'] =
          el.CY_Rate != null ? el.CY_Rate + ' / ' + el.Unit_Of_Measure : '';
        expData[this.forecastDetailsMap.get('nextYear_prev_no') + ' Rate'] =
          el.Future_Year_Rate != null ? el.Future_Year_Rate + ' / ' + el.Unit_Of_Measure : '';
        const chargeData = { ...expData };
        expData[this.forecastDetailsMap.get('previousYear_prev_no') + ' FY'] =
          el.volumes.Prev_Year_FY_Volume != null ? el.volumes.Prev_Year_FY_Volume : '';
        expData[this.forecastDetailsMap.get('currentYear_prev_no') + ' Projections'] =
          el.volumes.Infra_projected_Volumes != null ? el.volumes.Infra_projected_Volumes : '';
        expData[
          this.forecastDetailsMap.get('currentYear_prev_no') +
            ' FC (' +
            this.forecastDetailsMap.get('previousForecastCycle') +
            ')'
        ] = el.volumes.Curr_Year_FC_Prev_Volume != null ? el.volumes.Curr_Year_FC_Prev_Volume : '';
        expData[
          this.forecastDetailsMap.get('currentYear_prev_no') +
            ' FC (' +
            this.forecastDetailsMap.get('currentForecastCycle') +
            ')'
        ] = el.volumes.Curr_Year_FC_Curr_Volume != null ? el.volumes.Curr_Year_FC_Curr_Volume : '';
        expData[
          this.forecastDetailsMap.get('nextYear_prev_no') +
            ' FC (' +
            this.forecastDetailsMap.get('previousForecastCycle') +
            ')'
        ] = el.volumes.Future_Year_FC_Prev_Volume != null ? el.volumes.Future_Year_FC_Prev_Volume : '';
        expData[
          this.forecastDetailsMap.get('nextYear_prev_no') +
            ' FC (' +
            this.forecastDetailsMap.get('currentForecastCycle') +
            ')'
        ] = el.volumes.Future_Year_FC_Curr_Volume != null ? el.volumes.Future_Year_FC_Curr_Volume : '';
        volumeData.push(expData);
        chargeData[this.forecastDetailsMap.get('previousYear_prev_no') + ' FY'] =
          el.charges.Prev_Year_FY_Charges != null ? this.convertToDollar(el.charges.Prev_Year_FY_Charges) : '';
        chargeData[this.forecastDetailsMap.get('currentYear_prev_no') + ' Projections'] =
          el.charges.Infra_projected_Charges != null ? this.convertToDollar(el.charges.Infra_projected_Charges) : '';
        chargeData[
          this.forecastDetailsMap.get('currentYear_prev_no') +
            ' FC (' +
            this.forecastDetailsMap.get('previousForecastCycle') +
            ')'
        ] =
          el.charges.Curr_Year_FC_Prev_Charges != null
            ? this.convertToDollar(el.charges.Curr_Year_FC_Prev_Charges)
            : '';
        chargeData[
          this.forecastDetailsMap.get('currentYear_prev_no') +
            ' FC (' +
            this.forecastDetailsMap.get('currentForecastCycle') +
            ')'
        ] =
          el.charges.Curr_Year_FC_Curr_Charges != null
            ? this.convertToDollar(el.charges.Curr_Year_FC_Curr_Charges)
            : '';
        chargeData[
          this.forecastDetailsMap.get('nextYear_prev_no') +
            ' FC (' +
            this.forecastDetailsMap.get('previousForecastCycle') +
            ')'
        ] =
          el.charges.Future_Year_FC_Prev_Charges != null
            ? this.convertToDollar(el.charges.Future_Year_FC_Prev_Charges)
            : '';
        chargeData[
          this.forecastDetailsMap.get('nextYear_prev_no') +
            ' FC (' +
            this.forecastDetailsMap.get('currentForecastCycle') +
            ')'
        ] =
          el.charges.Future_Year_FC_Curr_Charges != null
            ? this.convertToDollar(el.charges.Future_Year_FC_Curr_Charges)
            : '';
        chargeArr.push(chargeData);
      });
      exportData.push(exportJSON);
    });
    this.exportService.exportToExcel(
      'Forecast Management',
      [exportData, chargeArr, volumeData],
      ['Forecast Details', 'Service Details at Charge Level', 'Service Details at Volume Level']
    );
  }

  convertToDollar(value: any): string {
    return value ? `$${Math.round(value).toLocaleString('en-US')}` : '$0';
  }

  getABSValue(value) {
    return Math.abs(value);
  }

  showHideRateAndUOM() {
    const columns = [];
    if (this.showUOMrateData) {
      // When toggling to show UOM and Rate
      this.expanded_columns.forEach(element => {
        if (element.key === 'sv_desc') {
          element.width = '18% !important';
        }
        columns.push(element.key);
      });
      this.displayedChildHeaders = [
        'No',
        'rate_uom',
        'header1',
        'header2',
        'header3',
        'header4',
        'header5',
        'header6',
        'header7'
      ];
      this.displayedChildColumns = ['sv_desc', 'PY_Rate', 'CY_Rate', 'Future_Year_Rate'];
    } else {
      // When toggling to hide UOM and Rate
      this.expanded_columns.forEach(element => {
        if (element.key === 'sv_desc') {
          element.width = '36% !important';
        }
        if (!(element.key === 'PY_Rate' || element.key === 'CY_Rate' || element.key === 'Future_Year_Rate')) {
          columns.push(element.key);
        }
      });
      this.displayedChildHeaders = ['No', 'header1', 'header2', 'header3', 'header4', 'header5', 'header6', 'header7'];
    }
    this.displayedChildColumns = columns;
    this.showUOMrateData = !this.showUOMrateData;
  }

  addService(element, type: string) {
    this.appDataForAddService = _.omit(element, 'childDataSource');
    this.modalType = type;
    this.addServicePopup.show();
  }

  addServiceWithApp(type: string) {
    this.modalType = type;
    this.getNewApplication();
    this.addServicePopup.show();
    if (Object.keys(this.marginLessDetails).length == 0) {
      this.getMarginLessDetails();
      this.addServicePopup.show();
    } else {
      this.addServicePopup.show();
    }
  }

  getMarginLessDetails() {
    const forecastCycle = this.masterServicesData['forecastData'].filter(item => item.Previous != 'Yes')[0];
    const startYear = forecastCycle['FC_Start_Month'].split(',')[0];
    const endYear = forecastCycle['FC_End_Month'].split(',')[0];
    const payload = {
      year: [startYear, endYear]
    };
    this.maintenanceService.getMarginLessDetails(payload).subscribe(
      response => {
        if (response) {
          this.marginLessDetails = response;
        }
      },
      error => {
        console.error('Error in getting marginless rates', error);
      }
    );
  }

  sortService(serviceLst) {
    const edit_toh_key = this.isForecastAdmin ? 'Admin_edit_toh' : 'edit_toh_table';
    let toggleStatus: boolean;
    if (this.toggle) {
      toggleStatus = this.toggle.checked;
    } else {
      toggleStatus = this.toggleChecked;
    }
    const FC_Curr_key = toggleStatus ? 'Curr_Year_FC_Curr_Charges' : 'Curr_Year_FC_Curr_Volume';
    const toggleValue = toggleStatus ? 'charges' : 'volumes';

    let editable_ntUpdated_serviceLst = serviceLst.filter(el => {
      return el.External_Link == null && el[edit_toh_key].toLowerCase() == 'yes' && el.attested_by == null;
    });
    editable_ntUpdated_serviceLst = this.maintenanceService.sortServiceList(
      editable_ntUpdated_serviceLst,
      toggleValue,
      FC_Curr_key,
      edit_toh_key
    );

    let editable_updated_serviceLst = serviceLst.filter(el => {
      return el.External_Link == null && el[edit_toh_key].toLowerCase() == 'yes' && el.attested_by != null;
    });
    editable_updated_serviceLst = this.maintenanceService.sortServiceList(
      editable_updated_serviceLst,
      toggleValue,
      FC_Curr_key,
      edit_toh_key
    );

    let non_editable_updated_serviceLst = serviceLst.filter(el => {
      return el.External_Link == null && el[edit_toh_key].toLowerCase() == 'no' && el.attested_by != null;
    });
    non_editable_updated_serviceLst = this.maintenanceService.sortServiceList(
      non_editable_updated_serviceLst,
      toggleValue,
      FC_Curr_key,
      edit_toh_key
    );

    let non_editable_ntUpdated_serviceLst = serviceLst.filter(el => {
      return el.External_Link == null && el[edit_toh_key].toLowerCase() == 'no' && el.attested_by == null;
    });
    non_editable_ntUpdated_serviceLst = this.maintenanceService.sortServiceList(
      non_editable_ntUpdated_serviceLst,
      toggleValue,
      FC_Curr_key,
      edit_toh_key
    );

    let non_editable_external_serviceLst = serviceLst.filter(el => {
      return el.External_Link != null;
    });
    non_editable_external_serviceLst = this.maintenanceService.sortServiceList(
      non_editable_external_serviceLst,
      toggleValue,
      FC_Curr_key,
      edit_toh_key
    );

    return [
      ...editable_ntUpdated_serviceLst,
      ...editable_updated_serviceLst,
      ...non_editable_updated_serviceLst,
      ...non_editable_ntUpdated_serviceLst,
      ...non_editable_external_serviceLst
    ];
  }
  refreshServicesForApp(event) {
    this.addServicePopup.hide();
    this.dataSource['data'].find((element, index) => {
      if (element.ask_global_id == event.ask_global_id) {
        const obj = this.refereshAppData(event);
        if (element['pending_Services'] > 0 && event.pending_Services == 0) {
          this.pendAttesCount--;
        } else if (element['pending_Services'] == 0 && event.pending_Services > 0) {
          this.pendAttesCount++;
        }
        element['app_Update_Status_ui'] = event.app_Update_Status_ui;
        element['pending_Services'] = event.pending_Services;
        element['Prev_FY_Total'] = obj['Prev_FY_Total'];
        element['Current_Projections_Total'] = obj['Current_Projections_Total'];
        element['Curr_Year_FC_Prev_Charges_Total'] = obj['Curr_Year_FC_Prev_Charges_Total'];
        element['Curr_Year_FC_Curr_Charges_Total'] = obj['Curr_Year_FC_Curr_Charges_Total'];
        element['Future_Year_FC_Prev_Charges_Total'] = obj['Future_Year_FC_Prev_Charges_Total'];
        element['Future_Year_FC_Curr_Charges_Total'] = obj['Future_Year_FC_Curr_Charges_Total'];
        element['services'] = event.services;

        const sorttedServiceLst = this.sortService(event.services);
        element['childDataSource'] = new MatTableDataSource(sorttedServiceLst);
        if (element.expand) {
          element.childDataSource.paginator = this.childpaginator.toArray()[index];
        }
        this.cd.detectChanges();
      }
    });
    this.refreshAggregatedData.emit(this.dataSource.data);
    this.innerTables.forEach((table, index) => {
      (table.dataSource as MatTableDataSource<any>).paginator = this.childpaginator.toArray()[index];
    });
    this.getNewApplication();
    this.cd.detectChanges();
  }

  //Function to sort the inner table data
  sortInnerTable(event, element) {
    if (!element.childDataSource || !element.childDataSource.data) {
      console.warn('childDataSource is null or undefined, skipping sort');
      return;
    }

    const data = element.childDataSource.data.slice();
    let isCharges = false;
    let isVolume = false;

    if (
      event.active == 'Infra_projected_Charges' ||
      event.active == 'Prev_Year_FY_Charges' ||
      event.active == 'Curr_Year_FC_Prev_Charges' ||
      event.active == 'Curr_Year_FC_Curr_Charges' ||
      event.active == 'Future_Year_FC_Prev_Charges' ||
      event.active == 'Future_Year_FC_Curr_Charges'
    ) {
      isCharges = true;
    }
    if (
      event.active == 'Infra_projected_Volumes' ||
      event.active == 'Prev_Year_FY_Volume' ||
      event.active == 'Curr_Year_FC_Prev_Volume' ||
      event.active == 'Curr_Year_FC_Curr_Volume' ||
      event.active == 'Future_Year_FC_Prev_Volume' ||
      event.active == 'Future_Year_FC_Curr_Volume'
    ) {
      isVolume = true;
    }
    const isAsc = event.direction === 'asc';
    element.childDataSource.data = data.sort((a, b) => {
      if (isVolume) {
        return this.compareValues(a.volumes[event.active], b.volumes[event.active], isAsc);
      } else if (isCharges) {
        return this.compareValues(a.charges[event.active], b.charges[event.active], isAsc);
      } else {
        return this.compareValues(a[event.active], b[event.active], isAsc);
      }
    });
  }

  //compare function to sort the data
  compareValues(valueA, valueB, isAsc) {
    return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
  }

  refereshAppData(val) {
    val['Prev_FY_Total'] = 0;
    val['Current_Projections_Total'] = 0;
    val['Curr_Year_FC_Prev_Charges_Total'] = 0;
    val['Curr_Year_FC_Curr_Charges_Total'] = 0;
    val['Future_Year_FC_Prev_Charges_Total'] = 0;
    val['Future_Year_FC_Curr_Charges_Total'] = 0;
    if (val.services && Array.isArray(val.services)) {
      val.services.forEach(el => {
        if (el.charges && el.charges.Prev_Year_FY_Charges != null) {
          val['Prev_FY_Total'] += el.charges.Prev_Year_FY_Charges;
        }
        if (el.charges && el.charges.Infra_projected_Charges != null) {
          val['Current_Projections_Total'] += el.charges.Infra_projected_Charges;
        }
        if (el.charges && el.charges.Curr_Year_FC_Prev_Charges != null) {
          val['Curr_Year_FC_Prev_Charges_Total'] += el.charges.Curr_Year_FC_Prev_Charges;
        }
        if (el.charges && el.charges.Curr_Year_FC_Curr_Charges != null) {
          val['Curr_Year_FC_Curr_Charges_Total'] += el.charges.Curr_Year_FC_Curr_Charges;
        }
        if (el.charges && el.charges.Future_Year_FC_Prev_Charges != null) {
          val['Future_Year_FC_Prev_Charges_Total'] += el.charges.Future_Year_FC_Prev_Charges;
        }
        if (el.charges && el.charges.Future_Year_FC_Curr_Charges != null) {
          val['Future_Year_FC_Curr_Charges_Total'] += el.charges.Future_Year_FC_Curr_Charges;
        }
        el['ask_global_id'] = val['ask_global_id'];
      });
    }
    return val;
  }

  checkForAllExpand(isExpand: boolean) {
    let count = 0;
    this.dataSource.data.forEach((val) => {
      if (val.expand == isExpand) {
        count++;
      }
    });
    return count;
  }

  expandAllFunc() {
    this.allRowsExpanded = !this.allRowsExpanded;
    this.dataSource.data.forEach((val) => {
      val.expand = this.allRowsExpanded;
    });
    this.cd.detectChanges();

    if (this.allRowsExpanded) {
      this.innerTables.forEach((table, index) => {
        const tableDataSource = table.dataSource as MatTableDataSource<any>;
        if (tableDataSource) {
          tableDataSource.paginator = this.childpaginator.toArray()[index];
        }
      });
    }
  }

  onPageChange() {
    setTimeout(() => {
      this.innerTables.forEach((table, index) => {
        (table.dataSource as MatTableDataSource<any>).paginator = this.childpaginator.toArray()[index];
      });
      this.cd.detectChanges();
    }, 100);
  }

  navigateToExternalLink(link, element) {
    this.pixelService.sendExternalclicktopixel(link, element);
    window.open(link, '_blank');
  }

  viewApplication(col, el) {
    const url = this.getNavigationLink(col, el);
    this.navigateToExternalLink(url, el);
  }

  //Function to filter data based on pending attestation
  applyPendingAttesFilter() {
    if (this.isPendingAttesFilterApplied) {
      return false;
    }
    const allData = this.dataSource.data;
    let filteredData: Array<any> = [];
    this.oldDataSource = allData;
    filteredData = allData.filter(val => val.pending_Services > 0);
    this.filterPendAttesData(filteredData, 'expanded');
    this.isPendingAttesFilterApplied = true;
  }

  //filter Data based on pending attestation
  filterPendAttesData(filteredData, state = 'expanded') {
    try {
      this.forecastTableData = filteredData;
      this.allRowsExpanded = false;
      this.dataSource = new MatTableDataSource(filteredData);
      this.dataSource.data.forEach((element, index) => {
        element['id'] = index;
        if (state === 'expanded') {
          element.expand = true;
          this.allRowsExpanded = true;
        } else {
          element.expand = false;
          this.allRowsExpanded = false;
        }
      });
      this.dataSource.paginator = this.paginator;
      this.TABLE_CONFIG.totalItems =
        this.dataSource && this.dataSource.data.length > 0 ? this.dataSource.data.length : 0;
    } catch (error) {
      console.error('Error filtering pending attestation data:', error);
    }
  }

  //Function to clear the filter applied for pending attestation
  clearPendAttesFilter() {
    const filteredData = this.oldDataSource;
    this.filterPendAttesData(filteredData, 'collapsed');
    this.isPendingAttesFilterApplied = false;
  }

  //Function to open Report Link
  openReportLink(event) {
    let filters = [];
    const queryParams = this.ReportsService.getWindowLocationSearch();
    if (queryParams.filters) {
      try {
        const parsedFilters = JSON.parse(queryParams.filters);
        if (parsedFilters.selectAll === 1) {
          filters = [];
        } else {
          Object.keys(this.RealFilter).forEach(key => {
            if (Array.isArray(this.RealFilter[key])) {
              if (key == 'lob') {
                const billingSegments = [];
                this.RealFilter[key].forEach(item => {
                  billingSegments.push(...item.Billing_Segment);
                });
                if (billingSegments.length > 0) {
                  filters.push({ Billing_Segment: billingSegments });
                }
              } else {
                if (this.RealFilter[key].length > 0) {
                  const excludedKeys = ['lifecycle', 'lob'];
                  if (!excludedKeys.includes(key))
                    filters.push({ [key]: [...new Set(this.RealFilter[key].map(item => item.name))] });
                }
              }
            }
          });
        }
        const filterkey = Object.keys(this.RealFilter);
        const urlkeys = Object.keys(parsedFilters);
        urlkeys.forEach(key => {
          if (!filterkey.includes(key)) {
            delete parsedFilters[key];
          }
        });
      } catch (error) {
        console.error('Error parsing filters from query params:', error);
      }
    }
    const url = this.ReportsService.createDynamicReport(filters, 'Infrastructure Forecast Report', 'Forecast Management','Current_Forecast');
    const src = window.location.origin + url;
    const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, src) || '';
    window.open(sanitizedUrl, '_blank');
    event.stopPropagation();
  }

  getNewApplication() {
    const payload = { role: 'Admin' };
    this.maintenanceService.getNewApplication(payload).subscribe({
      next: response => {
        this.allNewApps = response;
      },
      error: error => {
        console.error('Error fetching data:', error);
      }
    });
  }

  navigateToDynamicReportPage(el : any){
    const appid = el.ask_global_id.toString();
    const appName = el.app_name;
    const filters = [{ appId: [appid + ' ' + appName] }];
    const url = this.ReportsService.createDynamicReport(filters, 'Infra Consumption Details Report', 'Forecast Management','YrsByApp');
    const src = window.location.origin + url;
    const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, src) || '';
    window.open(sanitizedUrl, '_blank');
  }

  getForecastCycle(key){
    return this.forecastDetailsMap[key] ? this.forecastDetailsMap[key] : '';
  }

  exportData(data){
    const type = data.key;
    if(type == 'all'){
      this.exportToExcel();
    }else{
      const msid = this.sharedAuthService.getMsid() || '';
      const username = this.sharedAuthService.getUserName() || '';
      const payload = {
        report: type,
        selectedFilters: this.getSelectedFilters(),
        msid: msid,
        username: username,
        filename: data.fileName,
        type: data.type,
        page_name: data.page_name,
        filter: data.query_filter,
        report_type:  'Pre_defined_extract',
        baseWhere: data.baseWhere,
        defaultQuery: data.defaultQuery,
        element_name: data.element_name,
        element_type: data.element_type,
        tab_name: data.elementTab,
      };
      const apiData = { ...data, ...payload };
      this.checkDataInReport(apiData, payload);
    }
  }

  callADFPipelineAPI(payload){
    this.maintenanceService.callADFPipelineForExcelExport(payload).subscribe({
        next: response => {
          if(response && response['message'] === 'success'){
            this.toastr.success('Your export has been initiated. It will be available in <a href="/my-downloads" target="_self">My Downloads</a> in a few minutes.', '' , {
              enableHtml: true,
              timeOut: 5000,
              positionClass: 'toast-top-center'
            });
          }else{
            this.toastr.error('There was an error initiating your export. Please try again.', '' , {
              timeOut: 5000,
            positionClass: 'toast-top-center'
            });
          }
        },
        error: error => {
          this.toastr.error('There was an error initiating your export. Please try again.', '' , {
            timeOut: 5000,
            positionClass: 'toast-top-center'
          });
        }
      });
  }

  private openExportFileAsPopup(adfPayload: any, reportName: string, exportResponse?: any, shouldTriggerAdf: boolean = true): void {
    this.showDropdownMenu = false;
    this.exportPayloadPending = { ...adfPayload };
    this.exportResponseData = exportResponse;
    this.shouldTriggerAdfForExport = shouldTriggerAdf;
    const payloadFileName = adfPayload?.filename || reportName;
    this.exportFileAsPopup?.open(payloadFileName, 'Export File As');
  }

  closeExportFileAsPopup(): void {
    this.exportPayloadPending = null;
    this.exportResponseData = null;
    this.shouldTriggerAdfForExport = false;
  }

  confirmExportWithOptionalSuffix(resolvedFileName: string): void {
    if (!this.exportPayloadPending) {
      return;
    }
    const payload = {
      ...this.exportPayloadPending,
      filename: resolvedFileName
    };
    
    if (this.shouldTriggerAdfForExport) {
      // Trigger ADF pipeline export
      this.closeExportFileAsPopup();
      this.callADFPipelineAPI(payload);
    } else {
      // Direct Excel export with user-entered suffix in filename
      const rows = this.exportResponseData?.data;
      this.exportService.exportToExcel(payload.filename, [rows || []]);
      this.closeExportFileAsPopup();
    }
  }

  getReportDetailsForExcelExport() {
    this.isJSONeditorEnabled = this.isReportAdminRole();
    if(this.excelDropdownData && this.excelDropdownData.length > 0){
      return;
    }
    const dropdownData = this.maintenanceService.getForecastDropdownData();
    if(dropdownData && dropdownData.length > 0){
      this.excelDropdownData = dropdownData;
      return;
    }
    this.reportPayload = {
      Page_name: 'App Forecast Management',
      Report_Type: ['Pre_defined_extract']
    }
    this.ReportsService.getReportDetails(this.reportPayload).subscribe({
      next: response => {
        this.createExcelDropdownData(response);
      },
      error: error => {
        console.error('Error fetching report details for excel export:', error);
      }
    });
  }

  isReportAdminRole(): boolean {
    const pageData: Array<any> = this.inbuiltUtilityService.getUserRoles() || [];
    return pageData.length > 0;
  }
// Construct dropdown data for Excel export based on report metadata and user roles
  createExcelDropdownData(response: any) {
    if (response && response.length > 0) {
      const currentCycle = this.forecastDetailsMap.get('currentForecastCycle');
      const previousCycle = this.forecastDetailsMap.get('previousForecastCycle');
      const currentForecastYear = this.forecastDetailsMap.get('currentYear_prev_no');
      const dropdownData: { key: string; value: string; fileName?: string; query_filter?: string;Category?: string; page_name?: string; order?: number, baseWhere?: string, defaultQuery?: string, element_name?: string, element_type?: string, elementTab?: string , element_id?: string | number | null, raw_element_json?: any, Constructed_Query?: string }[] = [];
      response.forEach((report: any) => {
        
        let currentValue = report.Report;
        let defaultQuery = '';
        let baseWhere = '';
        let queryFilter = '';
        if(report.element_json){
          if(report.element_json.conditions){
            queryFilter = report.element_json.conditions;
            baseWhere = report.element_json.baseWhere;
            defaultQuery = report.element_json.defaultQuery;
          }
        }
        if(currentValue && currentValue.toLowerCase().includes('current cycle')) {
          currentValue = this.replaceDataInSting(currentValue, 'current cycle', currentForecastYear + ' ' + currentCycle);
        } else if(currentValue && currentValue.toLowerCase().includes('previous cycle')) {
          currentValue = this.replaceDataInSting(currentValue, 'previous cycle', currentForecastYear + ' ' + previousCycle);
        }else if(currentValue && currentValue.toLowerCase().includes('admin insights')) {
          if (!(this.isForecastAdmin || this.isForecastSRM)) {
            return; // Skip adding this report to the dropdown if the user is not an admin or SRM
          }
        }
        dropdownData.push({ key: report.Report, value: currentValue, fileName: `${currentValue.replace(/\s+/g, '_')}`, query_filter: queryFilter, Category: report.Category, page_name: report.Page_name, order: report.element_order, baseWhere: baseWhere, defaultQuery: defaultQuery, element_name: report.element_name || '', element_type: report.element_type || '', elementTab: report.tab_name || '', element_id: report.Id ?? report.element_id ?? null, raw_element_json: report.element_json || {}, Constructed_Query: report.Constructed_Query || {}});
      });
      this.excelDropdownData = dropdownData.length > 0 ? dropdownData.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) : [];
      this.maintenanceService.setForecastDropdownData(this.excelDropdownData);
    } else {
      this.excelDropdownData = [];
    }
  }

  checkDataInReport(data: any, adfPayload: any) {
    const requestPayload = {
      report: data.report,
      page: data.page_name,
      tab: data.elementTab,
      elementName: data.element_name,
      elementType: data.element_type,
      download: false,
      selectedFilters: data.selectedFilters,
      evaluateThresholdOnly: true
    };

    this.exportLoading = true;
    this.loadingExportKey = data.report;

    this.ReportsService.getInbuildTableData(requestPayload)
      .subscribe({
        next: (res: any) => {
          this.exportLoading = false;
          this.loadingExportKey = null;
          if (res.success) {
             if(res.count >= TOASTR_CONFIG.ROW_LIMIT){
                  this.toastrUtilsService.warning('The requested extract exceeds the maximum limit of 500,000 rows.<br>Please refine your filters and run the extract again.', '', {
                    enableHtml: true
                  });
                  return;
                }
            if (res.shouldTriggerAdf) {
              this.openExportFileAsPopup(adfPayload, data.report, res, true);
            } else if (res.count == 0) {
              this.toastr.warning('There is no Data in report based on selected Filters', '', {
                timeOut: 5000,
                positionClass: 'toast-top-center'
              });
               this.toastrUtilsService.applyBackgroundColor();
            } else {
              this.openExportFileAsPopup(adfPayload, data.report, res, false);
            }
          }
        },
        error: (error: any) => {
          this.exportLoading = false;
          this.loadingExportKey = null;
          console.error('API error: ', error);
          this.toastrUtilsService.error('There was an error checking report data. Please try again.');
        }
      });
  }

  replaceDataInSting(value: string, replaceData: string, replacement: string): string {
    const keyword = replaceData;
    const regex = new RegExp(keyword, 'gi');
    if(regex.test(value)){
      return value.replace(regex, replacement);
    }
    return value;
  }

  private setLobFilter(payload: any, lobSelection: any[]): void {
    if (lobSelection.length === 0) return;
    payload['Billing_Segment'] = lobSelection.flatMap(item => typeof item == 'string' ? this.updateBillingSegmentFilter(item) : item.Billing_Segment);
  }


  updateBillingSegmentFilter(item:string): string {
    if(!item) return '';
    let arr = item.split('-');
    //Remove the first index and return rest
    if(arr.length > 1)
      arr.shift();
    return arr.join('-');
  }

  private setSimpleSelectionFilter(payload: any, key: string, selection: any[], mapper: (item: any) => any): void {
    if (selection.length === 0) return;
    payload[key] = selection.map(mapper);
  }

  private isOwnerChipContext(): boolean {
    return this.clickedChip == 'delegate' || this.clickedChip == 'owners';
  }

  private applyOwnerSelection(payload: any, ownerSelection: any[]): void {
    const ids = ownerSelection.map(o => o.id);

    if (this.clickedChip === 'delegate') {
      payload['Delegates_MSID'] = ids;
      return;
    }

    if (this.clickedChip === 'owners') {
      const prefix = this.isLeaderOrOwnerSelected === 'leader' ? 'leader' : 'owner';
      const ownerTypes = Array.isArray(this.selectedOwnerType) ? this.selectedOwnerType : [];
      ownerTypes.forEach(type => {
        const dynamicKey = `${prefix}${type}Id`;
        payload[dynamicKey] = ids;
      });
    }
  }

  private decodeQueryParamValue(value: string, maxDepth = 3): string {
    let decoded = value;
    for (let i = 0; i < maxDepth; i++) {
      try {
        const nextValue = decodeURIComponent(decoded);
        if (nextValue === decoded) {
          break;
        }
        decoded = nextValue;
      } catch {
        break;
      }
    }
    return decoded;
  }

  private parseFilterJson(value: any, fallback: any): any {
    if (value === null || value === undefined) {
      return fallback;
    }

    if (typeof value !== 'string') {
      return value;
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return fallback;
    }

    try {
      return JSON.parse(trimmed);
    } catch {
      try {
        return JSON.parse(this.decodeQueryParamValue(trimmed));
      } catch {
        return fallback;
      }
    }
  }

  private applyQueryParamOwnerFallback(payload: any): void {
    this.activatedRoute.queryParams.subscribe(data => {
      try {
        const excluded = new Set([
          'selectedTab',
          'leaderSearch',
          'selectedOwnerType',
          'sv_desc',
          'App Lifecycle_Status',
          '__proto__',
          'constructor',
          'prototype'
        ]);
        const rawParams = this.parseFilterJson(data['filters'], {});

        Object.keys(rawParams)
          .filter(key => !excluded.has(key))
          .forEach(key => {
            const value = this.parseFilterJson(rawParams[key], rawParams[key]);
            Object.defineProperty(payload, key, { value, writable: true, enumerable: true, configurable: true });
          });
      } catch (e) {
        console.warn('Failed to parse filters query param:', data['filters'], e);
      }
    });
  }

  private remapOwnerKey(payload: any, fromKey: string, toKey: string): void {
    if (!payload[fromKey] || payload[fromKey].length <= 0) return;
    payload[toKey] = payload[fromKey];
    delete payload[fromKey];
  }

  private remapLeaderKey(payload: any, fromKey: string, targetKeys: string[]): void {
    if (!payload[fromKey] || payload[fromKey].length <= 0) return;

    const value = payload[fromKey];
    targetKeys.forEach(key => {
      payload[key] = value;
    });
    delete payload[fromKey];
  }

  private normalizeOwnerLeaderKeys(payload: any): void {
    this.remapOwnerKey(payload, 'ownerBOId', 'BusinessOwner_MSID');
    this.remapOwnerKey(payload, 'ownerSLOId', 'SLO_MSID');
    this.remapOwnerKey(payload, 'ownerTOId', 'TechOwner_MSID');

    this.remapLeaderKey(payload, 'leaderBOId', ['BO_L4_MSID', 'BO_L5_MSID', 'BO_L6_MSID', 'BO_L7_MSID', 'BO_L8_MSID']);
    this.remapLeaderKey(payload, 'leaderSLOId', ['SLO_L4_MSID', 'SLO_L5_MSID', 'SLO_L6_MSID', 'SLO_L7_MSID', 'SLO_L8_MSID']);
    this.remapLeaderKey(payload, 'leaderTOId', ['TO_L4_MSID', 'TO_L5_MSID', 'TO_L6_MSID', 'TO_L7_MSID', 'TO_L8_MSID']);
  }

  // Unified builder reducing duplication between payload and query param construction
  public getSelectedFilters() {
    const payload: any = {};
    const lobSelection = this.RealFilter.lob || [];
    const ownerSelection = this.RealFilter.owner || [];
    const lifecycleSelection = this.RealFilter.lifecycle || [];
    const serviceSelection = this.RealFilter.services || [];
    const appSelection = this.RealFilter.apps || [];
    this.setLobFilter(payload, lobSelection);
    this.setSimpleSelectionFilter(payload, 'App lifecycle_Status', lifecycleSelection, l => l.name);
    this.setSimpleSelectionFilter(payload, 'SV_Desc', serviceSelection, s => s.name);
    this.setSimpleSelectionFilter(payload, 'ASK_Global_Id', appSelection, a => a.id);

    if (this.isOwnerChipContext()) {
      if (ownerSelection.length > 0) {
        this.applyOwnerSelection(payload, ownerSelection);
      } else {
        this.applyQueryParamOwnerFallback(payload);
      }
    }

    this.normalizeOwnerLeaderKeys(payload);
    if(payload['delegateId'] && payload['delegateId'].length > 0){
      payload['Delegates_MSID'] = payload['delegateId'];
      delete payload['delegateId'];
    }
    return payload;
  }

  openJsonEditorForItem(item: any): void {
    this.activeDropdownItem = item;
    this.showDropdownMenu = false;
    this.isJsonEditorPopupOpen = true;
    this.jsonEditorPopup?.show?.();
  }

  closeJsonEditorItem(): void {
    this.isJsonEditorPopupOpen = false;
    this.jsonEditorPopup?.hide?.();
  }

  deleteReport(item: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.minHeight = '200px';
    dialogConfig.height = 'auto';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'Delete Confirmation!',
      subTitle: 'Are you sure you want to delete this report',
      buttonName: 'Continue'
    };

    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data !== 'cancel') {
        const reportId = item?.element_id ?? item?.id ?? item?.Id ?? null;
        const reportName = item?.value ?? item?.key ?? 'Report';
        this.ReportsService.deleteReport(reportId).subscribe({
          next: (_: any) => {
            this.toastr.success(`${reportName} has been deleted successfully`, '', {
              timeOut: 3000,
              positionClass: 'toast-top-center'
            });
            this.excelDropdownData = [];
            this.maintenanceService.setForecastDropdownData([]);
            this.getReportDetailsForExcelExport();
          },
          error: (_: any) => {
            this.toastr.error('Error deleting report', '', {
              timeOut: 3000,
              positionClass: 'toast-top-center'
            });
          }
        });
      }
    });
  }

  onJsonEditorItemTextChange(ev: any): void {
    if (!this.activeDropdownItem) return;
    const payload = {
      report: this.activeDropdownItem.key ?? '',
      Report_Type: 'Pre_defined_extract',
      Id: this.activeDropdownItem.element_id ?? null,
      element_json: ev || {},
    };
    this.ReportsService.updateReportJSON(payload).subscribe({
      next: (_: any) => {
        this.toastr.success('JSON updated successfully', '', { timeOut: 3000, positionClass: 'toast-top-center' });
        this.jsonEditorPopup?.hide?.();
        this.isJsonEditorPopupOpen = false;
        this.excelDropdownData = [];
        this.maintenanceService.setForecastDropdownData([]);
        this.getReportDetailsForExcelExport();
      },
      error: (_: any) => {
        this.toastr.error('Error updating JSON', '', { timeOut: 3000, positionClass: 'toast-top-center' });
      }
    });
  }
}
